import { render } from "./Label.vue?vue&type=template&id=3fc5a3fe"
import script from "./Label.vue?vue&type=script&setup=true&lang=js"
export * from "./Label.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fc5a3fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fc5a3fe', __exports__)) {
    api.reload('3fc5a3fe', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=3fc5a3fe", () => {
    api.rerender('3fc5a3fe', render)
  })

}


export default __exports__